import { get, reduce } from "lodash";

import { hasAdminOrPowerRole } from "src/services/auth";

export const ASSOCIATION_DIRECTION_MODE = {
  PROVIDER: "PROVIDER",
  CONSUMER: "CONSUMER",
  NON_DIRECTIONAL: "NON_DIRECTIONAL",
};

export const ASSOCIATION_DIRECTION_KEY = {
  [ASSOCIATION_DIRECTION_MODE.PROVIDER]: "p",
  [ASSOCIATION_DIRECTION_MODE.CONSUMER]: "c",
};

export const NEUTRAL_DIRECTION_KEY = "n";

export const directionKeyForMode = (mode) =>
  ASSOCIATION_DIRECTION_KEY[mode] || NEUTRAL_DIRECTION_KEY;

export const canAddAssociation = (user) => {
  return hasAdminOrPowerRole(user);
};

export const buildTagsByGroupId = (groupAssociations, subjectTeamName) =>
  reduce(
    groupAssociations,
    (acc, groupAssociation) => {
      const groupId = groupAssociation.group.id;
      if (!acc[groupId]) acc[groupId] = [];
      acc[groupId].push({
        ...groupAssociation.tag,
        associationDirection: groupAssociation.associationDirection || {
          mode: ASSOCIATION_DIRECTION_MODE.NON_DIRECTIONAL,
          description: null,
        },
        subjectTeamName,
        associatedTeamName: get(groupAssociation, "group.name"),
      });
      return acc;
    },
    {}
  );
